import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomButton from "../pages/CustomButton";
import { getAuthHeaders } from "../services/useAuth";
import { BASE_URL } from "../config";

export default function EmployeeExpense() {
  const [states, setStates] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [loading, setLoading] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [formData, setFormData] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/states`, { headers: getAuthHeaders() })
      .then((res) => setStates(res.data))
      .catch((err) => console.error("Error fetching states:", err));
  }, []);

  const handleStateChange = (stateName) => {
    setSelectedState(stateName);
    setSelectedEmployee("");
    setEmployees([]);
    setExpenses([]);

    const stateObj = states.find((s) => s.name === stateName);
    if (!stateObj) return;

    axios
      .get(`${BASE_URL}/api/employees?state_id=${stateObj.id}`, {
        headers: getAuthHeaders(),
      })
      .then((res) => setEmployees(res.data))
      .catch((err) => console.error("Error fetching employees:", err));
  };

  // const handleGoClick = () => {
  //   const stateObj = states.find((s) => s.name === selectedState);
  //   if (!stateObj || !selectedEmployee) return;

  //   setLoading(true);
  //   axios
  //     .get(
  //       `${BASE_URL}/api/employee-expense?state_id=${stateObj.id}&employee_id=${selectedEmployee}`,
  //       { headers: getAuthHeaders() }
  //     )
  //     .then((res) => {
  //       const enrichedData = res.data.map((exp) => {
  //         const emp = employees.find((e) => e.id === exp.employee_id);
  //         return {
  //           ...exp,
  //           state_name: stateObj.name,
  //           division: exp.division || emp?.division || "",
  //           designation: exp.designation || emp?.designation || "",
  //         };
  //       });
  //       setExpenses(enrichedData);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching expenses:", err);
  //       setLoading(false);
  //     });
  // };
const handleGoClick = () => {
  const stateObj = states.find((s) => s.name === selectedState);
  if (!stateObj) return;

  setLoading(true);

  let url = `${BASE_URL}/api/employee-expense?state_id=${stateObj.id}`;

  // ✅ Only add employee_id if NOT "all"
  if (selectedEmployee && selectedEmployee !== "all") {
    url += `&employee_id=${selectedEmployee}`;
  }

  axios
    .get(url, { headers: getAuthHeaders() })
    .then((res) => {
      const enrichedData = res.data.map((exp) => {
        const emp = employees.find((e) => e.id === exp.employee_id);
        return {
          ...exp,
          state_name: stateObj.name,
          division: exp.division || emp?.division || "",
          designation: exp.designation || emp?.designation || "",
        };
      });
      setExpenses(enrichedData);
      setLoading(false);
    })
    .catch((err) => {
      console.error("Error fetching expenses:", err);
      setLoading(false);
    });
};
  const handleChange = (e, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleEditExpense = (expense) => {
    setEditRow(expense.id);
    setFormData(expense);
  };

  const handleSave = () => {
    if (!editRow || !selectedEmployee) return;

    setSubmitting(true);

     const employeeId = selectedEmployee === "all" 
      ? formData.employee_id 
      : Number(selectedEmployee);

     const emp = employees.find((e) => String(e.id) === String(employeeId));
    const stateObj = states.find((s) => s.name === selectedState);

    // Format date properly
    const startDate = formData.start_date
      ? new Date(formData.start_date).toISOString().split("T")[0]
      : null;

    const payload = {
      id: editRow,
      employee_id: Number(employeeId),
      state_id: stateObj?.id || "",
      division_id: emp?.division_id || formData.division_id || "",
      designation_id: emp?.designation_id || formData.designation_id || "",
      division: emp?.division || formData.division || "",
      designation: emp?.designation || formData.designation || "",
      rate_km: Number(formData.rate_km) || 0,
      da_hq: Number(formData.da_hq) || 0,
      da_exstation: Number(formData.da_exstation) || 0,
      da_outstation: Number(formData.da_outstation) || 0,
      int_charge: Number(formData.int_charge) || 0,
      phone: formData.phone || "",
      vma: Number(formData.vma) || 0,
      fooding: Number(formData.fooding) || 0,
      other_charges: Number(formData.other_charges) || 0,
      hotel_charges: Number(formData.hotel_charges) || 0,
      ta: Number(formData.ta) || 0,
      total: Number(formData.total) || 0,
      remarks: formData.remarks || "",
      start_date: startDate,
      is_custom: formData.is_custom || true,
    };

    axios
      .put(`${BASE_URL}/api/employee-expense/${editRow}`, payload, {
        headers: getAuthHeaders(),
      })
      .then(() => {
        setExpenses((prev) =>
          prev.map((exp) => (exp.id === editRow ? { ...exp, ...payload } : exp))
        );
        setSubmitting(false);
        setEditRow(null);
        setFormData({});
      })
      .catch((err) => {
        console.error("Error updating expense:", err);
        setSubmitting(false);
      });
  };

  const handleCancel = () => {
    setEditRow(null);
    setFormData({});
  };

  const handleDeleteExpense = (expenseId) => {
    if (!window.confirm("Are you sure you want to delete this expense?"))
      return;

    axios
      .delete(`${BASE_URL}/api/employee-expense/${expenseId}`, {
        headers: getAuthHeaders(),
      })
      .then(() => {
        setExpenses((prev) => prev.filter((exp) => exp.id !== expenseId));
      })
      .catch((err) => console.error("Error deleting expense:", err));
  };

  // Helper function to format date or show message if not available
  const formatDate = (dateString) => {
    if (!dateString) return "No date set";

    try {
      const date = new Date(dateString);
      return isNaN(date.getTime()) ? "Invalid date" : date.toLocaleDateString();
    } catch (error) {
      return "Invalid date";
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow p-4">
        {/* Filter Section */}
        <div className="border rounded p-4 mb-6">
          <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
            <span className="text-blue-700">Employees </span>
            <span className="text-blue-500">Expense</span>
          </h1>

          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <label className="font-medium">State:</label>
            <select
              className="border rounded px-2 py-1"
              value={selectedState}
              onChange={(e) => handleStateChange(e.target.value)}
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.id} value={state.name}>
                  {state.name}
                </option>
              ))}
            </select>

            <label className="font-medium">Employee:</label>
           <select
  className="border rounded px-2 py-1"
  value={selectedEmployee}
  onChange={(e) => setSelectedEmployee(e.target.value)}
  disabled={!selectedState}
>
  <option value="">Select Employee</option>
  <option value="all">All Employees</option> {/* ✅ ADD THIS */}

  {employees.length > 0 ? (
    employees.map((emp) => (
      <option key={emp.id} value={emp.id}>
        {emp.first_name} {emp.last_name} | {emp.employee}  ({emp.designation} |{" "}
        {emp.headquarter_name} | {emp.division})
      </option>
    ))
  ) : (
    <option value="" disabled>
      No employees found
    </option>
  )}
</select>

            <CustomButton
              className="bg-green-500 text-white font-medium px-6 py-2 rounded"
              onClick={handleGoClick}
            >
              GO
            </CustomButton>
          </div>
        </div>

        {/* Expense Table */}
        {expenses.length > 0 && (
         <div className="border rounded shadow  table-wrapper">
        <table className="unlock-dcr-leave-table text-sm ">
          <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="border p-2">S.No</th>
                  <th className="border p-2">User Id</th>
                  <th className="border p-2">State</th>
                  <th className="border p-2">Division</th>
                  <th className="border p-2">Designation</th>
                  <th className="border p-2">RATE/KM</th>
                  <th className="border p-2">DA HQ</th>
                  <th className="border p-2">DA EX</th>
                  <th className="border p-2">DA OUT</th>
                  <th className="border p-2">INT CHARGE</th>
                  <th className="border p-2">Phone</th>
                  <th className="border p-2">VMA</th>
                  <th className="border p-2">Fooding</th>
                  <th className="border p-2">OTHER</th>
                  <th className="border p-2">Start Date</th>
                  <th className="border p-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="15" className="text-center p-4">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  expenses.map((row, index) => (
                    <tr key={row.id} className="text-center">
                      <td className="border p-2">{index + 1}</td>
                      <td className="border p-2">{row.employee}</td>
                      <td className="border p-2">{row.state_name}</td>
                      <td className="border p-2">{row.division}</td>
                      <td className="border p-2">{row.designation}</td>

                      {[
                        "rate_km",
                        "da_hq",
                        "da_exstation",
                        "da_outstation",
                        "int_charge",
                        "phone",
                        "vma",
                        "fooding",
                        "other_charges",
                      ].map((field) => (
                        <td key={field} className="border p-2">
                          {editRow === row.id ? (
                            <input
                              type="number"
                              value={formData[field] || ""}
                              onChange={(e) => handleChange(e, field)}
                              className="border rounded px-2 py-1 w-full"
                              pattern="[0-9]*"
                              inputMode="numeric"
                            />
                          ) : (
                            row[field]
                          )}
                        </td>
                      ))}

                      <td className="border p-2">
                        {editRow === row.id ? (
                          <input
                            type="date"
                            value={
                              formData.start_date
                                ? new Date(formData.start_date)
                                    .toISOString()
                                    .split("T")[0]
                                : ""
                            }
                            onChange={(e) => handleChange(e, "start_date")}
                            className="border rounded px-2 py-1 w-full"
                          />
                        ) : (
                          formatDate(row.start_date)
                        )}
                      </td>

                      <td className="border p-2">
                        {editRow === row.id ? (
                          <div className="flex gap-2 justify-center">
                            <CustomButton
                              label="Save"
                              onClick={handleSave}
                              variant="save"
                              disabled={submitting}
                            />
                            <CustomButton
                              label="Cancel"
                              onClick={handleCancel}
                              variant="cancel"
                              disabled={submitting}
                            />
                          </div>
                        ) : (
                          <div className="flex gap-2 justify-center">
                            <CustomButton
                              label="Edit"
                              onClick={() => handleEditExpense(row)}
                              variant="edit"
                              type="button"
                            />
                            <CustomButton
                              label="Delete"
                              onClick={() => handleDeleteExpense(row.id)}
                              variant="delete"
                              type="button"
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </main>

    </div>
  );
}
